/**
 * Lista de Situações Tributárias de IPI
 * Conforme Tabela da Receita Federal
 */

export interface IPISituacao {
  codigo: string;
  descricao: string;
  tipo: 'tributado' | 'isento' | 'suspenso';
}

export const IPISituacoes: IPISituacao[] = [
  {
    codigo: '01',
    descricao: 'Tributado',
    tipo: 'tributado'
  },
  {
    codigo: '02',
    descricao: 'Isento',
    tipo: 'isento'
  },
  {
    codigo: '03',
    descricao: 'Suspenso',
    tipo: 'suspenso'
  },
  {
    codigo: '04',
    descricao: 'Diferido',
    tipo: 'suspenso'
  },
  {
    codigo: '05',
    descricao: 'Tributado por Substituição Tributária',
    tipo: 'tributado'
  },
  {
    codigo: '06',
    descricao: 'Isento por Substituição Tributária',
    tipo: 'isento'
  },
  {
    codigo: '07',
    descricao: 'Isento por Supressão de ICMS',
    tipo: 'isento'
  },
];

/**
 * Situações mais comuns de IPI
 */
export const IPISituacoesMaisComuns = [
  IPISituacoes.find(s => s.codigo === '01')!,  // Tributado
  IPISituacoes.find(s => s.codigo === '02')!,  // Isento
  IPISituacoes.find(s => s.codigo === '03')!,  // Suspenso
];

/**
 * Validar se uma situação de IPI é válida
 */
export const isValidarIPISituacao = (situacao: string): boolean => {
  return IPISituacoes.some(s => s.codigo === situacao);
};

/**
 * Obter descrição de uma situação de IPI
 */
export const getDescricaoIPISituacao = (situacao: string): string => {
  const item = IPISituacoes.find(s => s.codigo === situacao);
  return item ? item.descricao : 'Situação inválida';
};
